
/**
 * @file  讲解管理系统
 * @create macaiqi 2022/01/12
 * @update
 */
import React, { useState, useRef, useEffect } from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useLocation } from 'react-router-dom';
import { IntroHeader } from '../header';
import { IntroFooter } from '../footer';
import { localDS } from '../../../storage';
import ReactWOW from 'react-wow'
import cls from 'classnames'
import './style.scss'
import { handleFreeTrial } from '../../../utils/productUtils';

/**
 * @description 讲解管理系统组件
 */
export const ExplainSystem = () => {
    const [index, setIndex] = useState(0)
    const [tabindex, setTabindex] = useState(1)
    const oDiv = useRef();
    const gnzc = useRef()
    const cptd = useRef()
    const { search } = useLocation()
    const [showTrialTip, setShowTrialTip] = useState(false);
    // 滚动到锚点
    const scrollToAnchor = (anchorName) => {
        setTabindex(anchorName)
        if (anchorName) {
            // 找到锚点
            let anchorElement = document.getElementById(anchorName);
            // 如果对应id的锚点存在，就跳转到锚点
            if (anchorElement) { anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
        }
    }
    useEffect(() => {
        // tab吸顶
        let divT = oDiv.current.offsetTop
        window.onscroll = function () {
            // 获取当前页面的滚动条纵坐标位置 （依次为火狐谷歌、safari、IE678）
            let scrollT = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

            if (scrollT >= divT) {
                if (window.navigator.userAgent.indexOf('MSIE 6.0') != -1) {
                    // 兼容IE6代码
                    // body[0].style.paddingTop = '50px'
                    oDiv.current.style.position = 'absolute';
                    oDiv.current.style.top = scrollT + 'px';
                    oDiv.current.style.left = 0 + 'px';
                } else {
                    // 正常浏览器代码
                    oDiv.current.style.position = 'fixed';
                    oDiv.current.style.top = 0;
                    oDiv.current.style.left = 0;
                }
                document.getElementById('content').style.paddingTop = 50 + 'px'
                for (let i = 0; i < tab.length; i++) {
                    if (scrollT >= document.getElementById(`${i + 1}`)?.offsetTop) {
                        document.getElementById(`link${i + 1}`).classList.add('active');
                        for (let j = 0; j < tab.length; j++) {
                            if (i !== j) {
                                document.getElementById(`link${j + 1}`).classList.remove('active');
                            }
                        }
                    }

                }
            } else {
                oDiv.current.style.position = '';
                document.getElementById('content').style.paddingTop = 0 + 'px'
                for (let j = 0; j < tab.length; j++) {
                    document.getElementById(`link${j + 1}`).classList.remove('active');
                }
            }

        }
        // 其他页面跳转尽量判断是否有锚点
        if (search.split('?')[1]) {
            scrollToAnchor(search.split('?')[1])
        }
    }, [cptd, gnzc, oDiv, search]);
    const tab = ['用户群体', '功能组成', '产品特点', '产品价格', '更新历史']
    // 功能组成
    const gongneng = [
        {
            name: "讲解员管理端",
            tab: ['档案管理', '排班管理', '任务管理', '讲解任务记录', '考核管理', '数据统计', '基础配置'],
            des: '提供讲解员档案信息的统一集中管理，主要功能包括新增、冻结、激活、修改、查看、查询。&&（1） 新增&&支持新增讲解员档案信息，主要包括讲解员姓名、手机号、证件号码、头像照片、专长等信息。',
            icon: 'iconshezhi'
        },
        {
            name: "讲解员小程序端",
            tab: [' 面向讲解员', '面向讲解员管理者'],
            des: '支持讲解员查看自己的讲解任务清单，跟踪各讲解任务状态，并根据状态提供一键开始讲解、结束讲解功能，主要功能包括任务查询、查看、开始讲解、结束讲解、查看讲解消息通知。',
            icon: 'iconxiaochengxu'
        },
        {
            name: "讲解预约小程序",
            tab: ['预约讲解', '讲解评价'],
            des: '支持观众在微信小程序端进行讲解预约。系统获取登记参观时间、参观人数、参观展厅、预约方式、联系人、联系方式、讲解员等信息后，发起讲解预约申请，等待管理员审核。',
            icon: 'iconhuodongyuyueguanli'
        }
    ]
    // 产品特点
    const tedian = [
        {
            name: '讲解员管理与服务全过程覆盖',
            des: '实现从讲解预约、任务发布、指派跟踪、任务执行、评价考核等全过程闭环管理。',
            icon: 'iconyizhanshijiejuefangan',
            duration: '1s',
            delay: '0.5s'
        },
        {
            name: '基于移动终端的便捷式管理',
            des: '支持微信小程序作为移动终端，快捷、高效地实现讲解员工作与服务管理。',
            icon: 'iconshouji21',
            duration: '1s',
            delay: '0.7s'
        },

    ]

    return (<>
        <IntroHeader />
        <div className="activity-appointment explain" id='content'>
            <div className="banner">
                <ReactWOW animation="fadeInLeft" duration="1.2s" delay="0.1s">
                    <div className="content">
                        <p className="big">讲解员管理系统</p>
                        <div className="cont">
                            建立讲解员的个人档案，制定并发布讲解任务，通过自动提醒让讲解员实时接收讲解任务，并一键完成签到/签退，实现讲解任务的便捷管理；自动汇总讲解时长、收集观众评价数据、记录领导定期考核结果，实现讲解员的绩效考核管理。通过讲解预约、任务发布、执行、评价的闭环管理，全面实现讲解任务管理的标准化和自动化。
                        </div>
                        <div className="btn">
                            {/* <div className="btn1" onClick={() => {
                                const token = localDS.get('saasToken')
                                if (!token) {
                                    window.location.href = "/accountLogin"
                                    return
                                }
                                let a = document.createElement("a"); // 创建一个<a></a>标签
                                a.href = `${window.location.origin}/pdf/explain.pdf`; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
                                a.download = "产品白皮书.pdf"; // 设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
                                a.style.display = "none"; // 障眼法藏起来a标签
                                document.body.appendChild(a); // 将a标签追加到文档对象中
                                a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
                                a.remove(); // 一次性的，用完就删除a标签
                            }}>
                                产品白皮书
                            </div> */}
                            {/* <div className="btn1">
                                观看演示
                            </div> */}
                            <div
                                className="btn2"
                                onClick={handleFreeTrial}
                                onMouseOver={() => { setShowTrialTip(true) }}
                                onMouseLeave={() => { setShowTrialTip(false) }}
                            >
                                免费试用
                                {showTrialTip && <div className='hov'>! 注册并申请机构实名认证后即可免费试用</div>}
                            </div>
                        </div>
                    </div>
                </ReactWOW>
            </div>
            <div className="tab" ref={oDiv}>
                <ul>
                    {tab?.map((item, index) => {
                        return (
                            <li key={index}>
                                <span onClick={() => scrollToAnchor(index + 1)} id={`link${index + 1}`} >{item}</span>
                            </li>
                        )
                    })}
                </ul>
            </div>

            <div className="people" id='1'>
                <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="0.5s">
                    <p className="title" >用户群体</p>
                </ReactWOW>
                <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="0.8s">
                    <p className="txt">本产品适用于博物馆、美术馆、图书馆、文化馆、科技馆、规划馆、校史馆、档案馆等各类公共文化场馆及其他有讲解员管理需求的企事业单位。
                    </p>
                </ReactWOW>
            </div>
            <div className="section2" id='2' ref={gnzc}>
                <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="1.1s">
                    <p className="title" id='two'>功能组成</p>
                </ReactWOW>
                <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="1s">
                    <div className="functionof">
                        {gongneng.map((item, i) => {
                            return (
                                <div className={cls('item', { active: index === i })} onClick={() => { setIndex(i) }} key={i}>
                                    <div className="moren">
                                        <i className={cls('iconfont', item.icon)} />
                                        <p className='tip'>{item.name}</p>
                                        {item.tab.map((item1, i1) => {
                                            return (<p className="txt" key={i1}>{item1}</p>)
                                        })}
                                    </div>
                                    <div className="activeitem">
                                        <p className='top'>
                                            <i className={cls('iconfont', item.icon)} />
                                            <span className='tip'>{item.name}</span>
                                        </p>
                                        <div className="cont">
                                            {item.des.includes("&&") ? item.des.split('&&').map((val, index2) => {
                                                return (
                                                    <p key={index2}>{val}</p>
                                                )
                                            }) : item.des}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}

                    </div>
                </ReactWOW>
            </div>
            <div className="section3" id='3' ref={cptd}>
                <ReactWOW animation="fadeInUp-little" duration="1s" delay="0.5s">
                    <p className="title">产品特点</p>
                </ReactWOW>
                <div className="section3-box">
                    {tedian.map((item, index) => {
                        return (
                            <ReactWOW animation="fadeInUp-little" key={index} duration={item.duration} delay={item.delay}>
                                <div className="item">
                                    <div className="itembox">
                                        <div className="l">
                                            <i className={`iconfont ${item.icon}`} />
                                        </div>
                                        <div className="r">
                                            <p className="tip">{item.name}</p>
                                            <p className='txt'>{item.des}</p>
                                        </div>
                                    </div>
                                </div>
                            </ReactWOW>
                        )
                    })}
                </div>

            </div>
            <div className="section4" id='4' ref={cptd}>
                <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="0.5s">
                    <p className="title">产品价格</p>
                </ReactWOW>
                <ReactWOW animation="fadeInUp-little" duration="1.2s" delay="0.8s">
                    <div className="box">
                        <div className="price">
                            <div className="l">
                                <div className="red">
                                    <span>4800</span>
                                    元/年
                                </div>
                            </div>
                            {/* <div className="buy">立即购买</div> */}
                        </div>

                    </div>
                </ReactWOW>
            </div>
            <div className="update" id='5'>
                <div className="updatebox">
                    更新历史
                    <i className="jian" />
                    {/* <span style={{ marginLeft: 10 }}>2021年9月26日正式发布</span> */}
                </div>
            </div>
        </div>
        <IntroFooter />
    </>
    )
}
